/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Загрузка...',
	'dlg_close': 'Закрыть',
	'dlg_ok': 'ОК',
	'dlg_cancel': 'Отмена',
	'dlg_back': 'Перейти назад',
	'dlg_done': 'Готово',
	'dlg_save': 'Сохранить',

	// Slider
	'sliderRegionLabel': 'Элемент управления ползунком; чтобы переместить хэндлы ползунка, используйте стрелки вправо и влево',
	'sliderHandleLabel': 'Хэндл ползунка',
	'a11ySliderHandleLabel': 'Ручка ползунка %{sliderValue}',
	'sliderInputLabel': 'значение',

	// Side bar
	'sidebarAdd': 'Добавить',
	'clearTextFilterValue': 'Очистить',
	'missingDataSetData': 'Данные для этого набора данных недоступны. Обновите набор данных или обратитесь к своему администратору, чтобы получить доступ к источнику.',

	// Toolbar
	'toolbarRegionLabel': 'Панель инструментов',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Семейство шрифтов',
	'fontFamilyStyle': 'Тип шрифта',
	'regularFontStyle': 'Обычный',
	'fontSizeSelect': 'Размер шрифта',
	'fontColorSelect': 'Цвет',
	'fontStyle': 'Стиль',
	'colorPickerTitle': 'Выбор цвета',
	'bold': 'Полужирный',
	'italic': 'Курсив',
	'underline': 'Подчеркивание',
	'fontAlignment': 'Выравнивание',
	'justifyLeft': 'Выровнять по левому краю',
	'justifyCenter': 'Выровнять по центру',
	'justifyRight': 'Выровнять по правому краю',
	'insertOrderedList': 'Упорядоченный список',
	'insertUnorderedList': 'Неупорядоченный список',
	'fontColorPicker': 'Выбор цвета',
	'textWrap': 'Перенос текста',
	'restore': 'Восстановить значения по умолчанию',
	'textAutoFontSize': 'Автоматически',
	'textDefaultFontSize': 'Значение по умолчанию',
	'textItemTitle': 'Название',
	'textLabelShadow': 'Тень метки',
	'textContrastLabelColor':'Контрастный цвет',
	'toggleOn': 'Вкл',
	'toggleOff': 'Выкл',
	'contrastLabelColorInfo': 'Автоматическая корректировка цвета метки для поддержки специальных возможностей. Этот параметр переопределяет цвет шрифта.',
	'labelShadowInfo':'Добавить тень текста для поддержки специальных возможностей.',
	'applyToAll':'Применить стиль ко всем осям',

	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Число результатов (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Процент (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Опция Первые или последние',
	'topbottomOptionLabel': 'Показать',
	'searchByLabel': 'На основе',
	'searchNoMatches': 'Совпадения не найдены',
	'topbottomRankColumnLabel': 'Добавить в таблицу столбец ранга',
	'topbottomNone': 'Нет',
	'topCount': 'Число первых',
	'topPercent': 'Первые %',
	'bottomCount': 'Число последних',
	'bottomPercent': 'Последние %',
	'searchColumn': 'Найти столбец',
	'searchColumnAriaLabel': 'Найдите столбец. Введите имя столбца, который нужно искать, а затем используйте стрелку вниз, чтобы найти столбец в списке',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Ранг (%{columnLabel})',
	'topbottomClearLabel': 'Сброс',

	// Format
	'formatAuto': 'Автоматически',
	'formatConvertPercent': 'Преобразовать десятичное число в процент',
	'formatAbbreviate': 'Сокращать',
	'formatUseGrouping': 'Использовать разделитель тысяч',
	'dateStyle': 'Стиль дат',
	'dateTimeStyle': 'Стиль даты и времени',
	'formatMissingValueCharactersInfo': 'Символы пропущенных значений позволяют указать символы, которые должны появляться на экране вместо пропущенного значения.',
	'currencySymbolLabel': 'Обозначение валюты',
	'customSymbolPlaceholder': 'Добавить символ',
	'customSymbolLabelInfo': 'Указывает символ или символы для использования в качестве пользовательского символа. Этот символ будет предшествовать числу и любому знаку.',
	'numberLabel': 'Числовая метка',
	'numberPositionLabel': 'Положение метки',
	'negativeSignPosition': 'Положение отрицательного знака',
	'negativeSign': 'Символ отрицательного знака',
	'numberLabelInfo': 'Определяет метку для отформатированного числа и помещается в виде префикса или суффикса в зависимости от положения метки.',
	'nullValueDefault': '<по умолчанию>',
	'nullValueContent': '(нет значения)',
	'default': 'По умолчанию',
	'beginning': 'Начало',
	'end': 'Конец',
	'formatLabel': 'Выберите формат',

	// More data indicator
	'moreDataIndicator': 'Ваши данные обрезаны на уровне %{threshold} элементов. Примените фильтр, чтобы показать меньше данных.',

	// Expanded View / Focus mode
	'evCollapse': 'Свернуть',
	'duplicate': 'Дублировать',
	'copyOf': 'Копия %{name}',
	'unableToDuplicateBoard': 'Не удается дублировать "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Мы не можем загрузить объекты.',

	// Custom widgets
	'customWidget': 'Пользовательский виджет',

	// Auto group
	'group': 'Группа',

	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'С засечками',
	'textFontFamilySubClassThin': 'Тонкий',
	'textFontFamilySubClassThinItalic': 'Тонкий курсив',
	'textFontFamilySubClassExtraLight': 'Сверхсветлый',
	'textFontFamilySubClassExtraLightItalic': 'Сверхсветлый курсив',
	'textFontFamilySubClassLight': 'Светлый',
	'textFontFamilySubClassLightItalic': 'Светлый курсив',
	'textFontFamilySubClassRegular': 'Нормальный',
	'textFontFamilySubClassRegularItalic': 'Нормальный курсив',
	'textFontFamilySubClassItalic': 'Курсив',
	'textFontFamilySubClassMedium': 'Средний',
	'textFontFamilySubClassMediumItalic': 'Средний курсив',
	'textFontFamilySubClassHeavy': 'Плотный',
	'textFontFamilySubClassHeavyItalic': 'Плотный курсив',
	'textFontFamilySubClassDemiBold': 'Полужирный',
	'textFontFamilySubClassDemiBoldItalic': 'Полужирный курсив',
	'textFontFamilySubClassBold': 'Жирный',
	'textFontFamilySubClassBoldItalic': 'Жирный курсив',
	'textFontFamilySubClassExtraBold': 'Сверхжирный',
	'textFontFamilySubClassExtraBoldItalic': 'Сверхжирный курсив',
	'textFontFamilySubClassBlack': 'Черный',
	'textFontFamilySubClassBlackItalic': 'Черный курсив',
	'textFontFamilySubClassStencil': 'Трафарет',
	// END: Remove FontFamilySubClass
});
